import React from 'react';
import { IconProps } from '.';

const SvgCartArrivals = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M20.856 12.325A6.5 6.5 0 1 0 10.043 6.75H6.62l-.33-3H1.5v1.5h3.446l1.323 12h13.145l1.451-4.934-.009.008Zm-1.91 1.199a6.501 6.501 0 0 1-8.904-5.274H6.787l.827 7.5h10.679l.654-2.226ZM21.5 7.5a5 5 0 1 1-5.75-4.944v5.633l-1.72-1.72-1.06 1.061 3.53 3.53 3.53-3.53-1.06-1.06-1.72 1.72V2.555A5.001 5.001 0 0 1 21.5 7.5Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M11 20a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16.5 21.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
      />
    </svg>
  );
};

export default SvgCartArrivals;
